import { render, staticRenderFns } from "./Bankpay.vue?vue&type=template&id=4f4f277d&scoped=true&"
import script from "./Bankpay.vue?vue&type=script&lang=js&"
export * from "./Bankpay.vue?vue&type=script&lang=js&"
import style0 from "./Bankpay.vue?vue&type=style&index=0&id=4f4f277d&lang=scss&scoped=true&"
import style1 from "./Bankpay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f277d",
  null
  
)

export default component.exports